import { useAsyncMemo } from 'use-async-memo'

export default useAsyncMemo
